import { ValidationErrors } from "@compass/core";
import {
  Permission,
  ContributorMatch,
  ContributorMatchEditResource,
  ContributorMatchViewResource,
} from "generated/openApi";
import { ContributorMatchPageBody } from "pages/match-main/contributor-matches/ContributorMatchPage/ContributorMatchPageBody/ContributorMatchPageBody";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const MatchInfo = (props: {
  match: ContributorMatch;
  setMatch: (value: ContributorMatch) => void;
  validationErrors: ValidationErrors | string[];
}) => {
  const [viewResource, setViewResource] = useState<ContributorMatchViewResource>({} as ContributorMatchViewResource);
  const [editResource, setEditResource] = useState<ContributorMatchEditResource>({} as ContributorMatchEditResource);

  useEffect(() => {
    fetchViewResource();
    fetchEditResource();
  }, []);

  const fetchViewResource = () => {
    ApiService.contributorMatches.getViewResource().then((response) => {
      setViewResource(response);
    });
  };

  const fetchEditResource = () => {
    ApiService.contributorMatches.getEditResource().then((response) => {
      setEditResource(response);
    });
  };

  return (
    <ContributorMatchPageBody
      rootPermission={Permission.ContributorMatch}
      match={props.match}
      setMatch={props.setMatch}
      crudMode={"edit"}
      viewResource={viewResource}
      editResource={editResource}
      validationErrors={props.validationErrors}
      hideContributor
      hideEmployment
    />
  );
};
